export default __webpack_public_path__ + "static/media/cleaning-products.7c9a9737.jpeg";